import React from 'react'
import Moment from 'react-moment'
import { StatusTag } from 'components'
import { Icon } from 'semantic-ui-react'

export const columns = [
  {
    Header: '',
    accessor: 'isSpecialCreditTerm',
    width: 30,
    Cell: row => (row.value && <Icon name='star' color='yellow' />)
  },
  {
    Header: 'Status',
    accessor: 'status',
    className: 'center',
    width: 140,
    Cell: row => (<StatusTag isBilling status={row.value} statusName={row.original.statusName} />)
  },
  {
    Header: 'Doc No.',
    accessor: 'documentNumber',
    width: 100,
  },
  {
    Header: 'Title',
    accessor: 'title',
    headerClassName: 'left',
    width: 250,
  },
  {
    Header: 'Vendor',
    accessor: 'vendorName',
  },
  {
    Header: 'Company',
    accessor: 'companyName',
  },
  {
    Header: 'Requester',
    accessor: 'requesterName',
  },
  {
    Header: 'Submitted date',
    accessor: 'submittedDate',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : null)
  },
  {
    Header: 'Modified date',
    accessor: 'modifiedDate',
    width: 120,
    Cell: row => (row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : null)
  }
]